import { render, staticRenderFns } from "./BusinessTask.vue?vue&type=template&id=7d7495f2&scoped=true&"
import script from "./BusinessTask.vue?vue&type=script&lang=js&"
export * from "./BusinessTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7495f2",
  null
  
)

export default component.exports